import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

const Fade = ({ children, show }) => {
  const [shouldRender, setRender] = useState(show)

  const onAnimationEnd = () => {
    if (!show) setRender(false)
  }

  useEffect(() => {
    if (show) setRender(true)
  }, [show])

  return (
    shouldRender && (
      <div style={{ animation: `${show ? 'responseFadeIn' : 'responseFadeOut'} .5s` }} onAnimationEnd={onAnimationEnd}>
        {children}
      </div>
    )
  )
}

Fade.propTypes = {
  children: PropTypes.any,
  show: PropTypes.bool
}

export default Fade
